module.exports = "<div [id]=\"this.chartSpecification.divId\" class=\"chartDiv\" [hidden]=\"!drawIt\"></div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/barCharts/multipleBarChart/multipleBarChart.component.html
// module id = ../../../../../app/shared/components/charts/barCharts/multipleBarChart/multipleBarChart.component.html
// module chunks = main